module.exports = __webpack_public_path__ + "img/ico-fijo-s.769f592b.svg";